import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OxygenAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-oxygen-slot',
    templateUrl: './oxygen-slot.component.html',
    styleUrl: './oxygen-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OxygenSlotComponent implements SheetSlotComponentBase {

	action!: OxygenAction;
	value!: string | null;

	@Input('action') set updateAction(action: OxygenAction | null) {
		this.action = action as OxygenAction;
		this.value = this.action.percentageGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}